module.exports = __webpack_public_path__ + "static/img_1860-6db6eee95751151daeea6ed47b7db73d.webp";